import React from 'react'

import FieldLabelWrapper from '../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../components/Form/Field'

import {
  GENDER_FEMALE,
  GENDER_MALE,
  GENDER_UNLIMITED
} from '../../../../../LineItemTikTokCreate/LineItemTikTokCreateForm/fields'
import { GENDER_OPTION } from '../../../../../../../ReusableFormFields/GenderFields/fields'

const tikTokGenderOptions = [
  { value: GENDER_MALE, label: 'Only males' },
  { value: GENDER_FEMALE, label: 'Only females' },
  { value: GENDER_UNLIMITED, label: 'All' }
]

const GenderContent = ({ formik }) => {
  return (
    <FieldLabelWrapper label="Gender">
      <Field
        formik={formik}
        name={GENDER_OPTION}
        placeholder="Gender"
        options={tikTokGenderOptions}
        isSearchable={false}
      />
    </FieldLabelWrapper>
  )
}

export default GenderContent
